import { BreadcrumbV2 } from "#src/commonV2/Breadcrumb";
import { EndpointDlpExternalStoragePeripheralPolicy } from "#src/components/endpoint/dlp/externalStorage/PeripheralPolicySection";
import { pathname } from "#src/config/pathname";
import { useTranslation } from "react-i18next";
import { useParams, generatePath } from "react-router-dom";

export const EndpointDlpExternalStorage = () => {
  const { t } = useTranslation("endpoint", {
    keyPrefix: "dlp.externalStorage",
  });

  const { workspaceId } = useParams<"workspaceId">();

  if (!workspaceId) {
    return null;
  }

  // --------------- STATES ---------------

  // --------------- HOOKS ---------------

  // --------------- METHODS ---------------

  // --------------- COMPUTED ---------------

  // --------------- EFFECTS ---------------

  // --------------- RENDER ---------------

  return (
    <>
      <div className="pt-5 pb-6 flex flex-col gap-5 min-h-screen">
        {/* Header (Breadcrumb + title) */}
        <div className="px-8 flex flex-col gap-4">
          <BreadcrumbV2
            levels={[
              {
                name: t("breadcrumb.levels.endpoint"),
                path: generatePath(pathname.ENDPOINT_OVERVIEW, { workspaceId }),
              },
            ]}
            currentPage={{
              name: t("breadcrumb.current.dataLossPrevention"),
              tab: t("breadcrumb.current.externalStorageDevices"),
            }}
          />
          <span className="text-display-xs font-semibold text-gray-v2-900">
            {t("title")}
          </span>
        </div>
        {/* Header (Breadcrumb + title) end */}

        <div className="px-8 pb-12">
          {/* Peripheral policies */}
          <EndpointDlpExternalStoragePeripheralPolicy />
          {/* Peripheral policies end */}
        </div>
      </div>
    </>
  );
};
